parseURL = require 'url-parse'

module.exports = (url) ->
  parseURL(url, {}).host == location.host
